module.exports = __webpack_public_path__ + "assets/img/yzzx_medinhealth.443b3ce1.png";